import { MB_CONFIG } from '../config'

export default {

    DAY: day => axios.get(MB_CONFIG.API_URL + '/calendar/day/' + day),

    WEEK: ({ year, week }) => axios.get(MB_CONFIG.API_URL + '/calendar/week/' + year + '/' + week),

    SAVE: appointment => appointment.id ? axios.put(MB_CONFIG.API_URL + '/calendar/' + appointment.id, appointment) : axios.post(MB_CONFIG.API_URL + '/calendar', appointment),

    DELETE: (type, id) => axios.delete(MB_CONFIG.API_URL + '/calendar/' + type + '/' + id),

    TIMELINE: () => axios.get(MB_CONFIG.API_URL + '/calendar/timeline'),

    PREV_TIMELINE: (time) => axios.get(MB_CONFIG.API_URL + '/calendar/timeline/' + time + '/<'),

    NEXT_TIMELINE: (time) => axios.get(MB_CONFIG.API_URL + '/calendar/timeline/' + time + '/>'),

}
